<template>
  <div>
    Por favor espera un segundo mientras te dirigimos a la página
  </div>
</template>

<script lang="js">
import axios from "axios";

export default {
  name: "UrlRedirector",
  mounted() {
    
    const { webId, sessionId } = this.$route.params;
    const currentLink = window.location.href;
    const newLink = currentLink.split("redirect")[1].split("/").slice(3).join("/");
    
    axios.post(
      `${process.env.VUE_APP_TRACKERDATA_URL}/track_link`,
      { web_id: webId, session_id: sessionId, link: newLink }
    ).then(() => {
      console.log("Redirecting");
      window.location.href = newLink;
    })
  },
}

</script>